import setCurrentSearchQueryId from 'owa-search/lib/mutators/setCurrentSearchQueryId';
import setNextSearchQueryId from 'owa-search/lib/mutators/setNextSearchQueryId';
import { getGuid } from 'owa-guid';
import { startSearch, startSearchSession } from 'owa-search-actions';
import { SearchScenarioId, getScenarioStore } from 'owa-search-store';
import { invokeTimestreamSearch, getSearchQueryString } from 'owa-timestream-search-orchestration';
import { orchestrator } from 'satcheljs';
import { searchFilters } from '../selectors/searchFilters';
import { format } from 'owa-localize';

/**
 * Starts search on user input by invoking the substrate API
 */
export default orchestrator(startSearch, async actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.Spaces) {
        return null;
    }

    let searchStore = getScenarioStore(SearchScenarioId.Spaces);

    // If we are here then we must have something to search!
    if (searchStore.searchText.length == 0 && searchStore.suggestionPillIds.length == 0) {
        throw new Error(
            format(
                'Spaces {0}: StartSearch should not be called with an empty search!!',
                actionMessage.actionSource
            )
        );
    }

    // SearchSessionGuid is set in startSearchSession as a part of initialization code.
    // If it was not set due to lazy loading of the script and user intiating the search mean while
    // we will call startSearchSession here again.
    if (!searchStore.searchSessionGuid) {
        startSearchSession(
            actionMessage.actionSource,
            true /* shouldStartSeach */,
            SearchScenarioId.Spaces
        );
        return null;
    }

    let queryString = getSearchQueryString();

    // We're starting a new search query for the first page so we need to update the query IDs.
    setCurrentSearchQueryId(searchStore.nextSearchQueryId, SearchScenarioId.Spaces);
    setNextSearchQueryId(getGuid(), SearchScenarioId.Spaces);

    // if by this time the searchQueryId had been reset in the store, it means user has exited search, so do not proceed
    if (searchStore.currentSearchQueryId == null) {
        return null;
    }

    const assetSearchRequests = [
        {
            queryString: queryString,
            includesPeopleSuggestion: searchStore.suggestionPillIds.length > 0,
            filters: searchFilters(),
        },
    ];
    invokeTimestreamSearch(actionMessage.actionSource, assetSearchRequests);
});
